import moment from 'moment'

export const UI_LANGUAGES_SET_CURRENT_LANGUAGE = 'UI_LANGUAGES_SET_CURRENT_LANGUAGE'
export const UI_LANGUAGES_SET_UI_LANGUAGES_ID = 'UI_LANGUAGES_SET_UI_LANGUAGES_ID'

export default {
  state: {
    currentLanguage: null,
    currentLanguageId: null,
    uiLanguages: {}
  },
  mutations: {
    [UI_LANGUAGES_SET_CURRENT_LANGUAGE](state, { value, ids }) {
      let locale = 'en'

      switch (value) { // [TODO] Remove fcking moment and fix this shit
        case 'ces':
          locale = 'cs'
          break
        case 'eng':
          locale = 'en'
          break
        case 'deu':
          locale = 'de'
          break
        case 'slk':
          locale = 'sk'
      }

      moment.locale(locale)

      state.currentLanguage = value
      localStorage.ui_language = value
      if (ids) {
        localStorage.ui_language_id = JSON.parse(ids)[value]
        state.currentLanguageId = JSON.parse(ids)[value]
      }
    },
    [UI_LANGUAGES_SET_UI_LANGUAGES_ID](state, { data }) {
      state.uiLanguages = data
      localStorage.ui_languages_id = JSON.stringify(data)
    }
  }
}
